/**
 * Парсит строку с одним или несколькими объектами гражданства.
 * @param {string} citizenshipString - Строка с информацией о гражданстве.
 * @returns {Array<{ country: string, flag: string }>} Массив объектов с информацией о гражданстве.
 */
export default function parseCitizenshipString(citizenshipString: string): Array<{ country: string, flag: string }> {
	// Убираем возможные пробелы в начале и конце строки
	const trimmedString = citizenshipString.trim();

	// Проверяем, начинается ли строка с { и заканчивается на }
	if (!trimmedString.startsWith('{') || !trimmedString.endsWith('}')) {
		console.error('Invalid citizenship string format');
		return [];
	}

	// Разделяем строку на отдельные объекты
	const objectStrings = trimmedString.split('}, {').map(str =>
		str.replace(/^{/, '').replace(/}$/, '')
	);

	return objectStrings.reduce<Array<{ country: string, flag: string }>>((acc, objStr) => {
		try {
			const obj = JSON.parse(`{${objStr}}`);
			if (typeof obj.country === 'string' && typeof obj.flag === 'string') {
				acc.push({
					country: obj.country,
					flag: obj.flag
				});
			} else {
				console.error('Invalid object structure:', obj);
			}
		} catch (error) {
			console.error('Error parsing citizenship object:', error);
		}
		return acc;
	}, []);
}

// Пример использования:
// const citizenshipString = '{"country":"Brazil","flag":"files/flags/brazil.svg"}, {"country":"Russia","flag":"files/flags/russia.svg"}';
// const citizenships = parseMultipleCitizenships(citizenshipString);
// citizenships.forEach(citizenship => {
//   console.log(citizenship.country);
//   console.log(citizenship.flag);
// });